<template>
  <div class="about container">
    <div class="row">
      <div class="col-12 col-lg-10 offset-lg-1" />
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'About',
  components: {
    Card,
    FormComponent,
    InputText,
    InputTextArea,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      streetAddress: '',
      city: '',
      state: '',
      zip: '',
      country: '',

      userClient: new UserClient(this.$http),
      saving: false,
    };
  },
  mounted() {
    window.location.href = 'https://www.meetvirginia.io/legal/do-not-sell-my-info';
  },
  methods: {
    doContact() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          this.saving = true;
          this.userClient.submitDoNotSell({
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            street: this.streetAddress,
            city: this.city,
            state: this.state,
            zip: this.zip,
            country: this.country,
          }).then((response) => {
            this.saving = false;
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.streetAddress = '';
            this.city = '';
            this.state = '';
            this.zip = '';
            this.country = '';
            this.$globals.showSuccess('Your information has been saved.');
          }).catch((ex) => {
            this.saving = false;
            this.$globals.showError('Failed to save info. Please try again!', ex);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  /deep/ .card {
    @media (min-width: $md-min) {
      padding: 80px;
    }
  }
}
</style>
